import { ContactType } from '@/core/domain/_shared/ContactType';
import { ContactDetailList } from '@/core/domain/people/_shared/Contact';
import removeMask from './removeMask';

export function removeMaskDetailList<T extends Partial<ContactDetailList>>(
  detailList: T[],
) {
  return detailList.map((item) => ({
    ...item,
    value:
      item.contactType !== ContactType.Email
        ? removeMask(item.value)
        : item.value,
  }));
}
